import { Shield } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isSuperAdmin } from "@/lib/roles";

// Barra fina no topo (sticky) exibida quando o Super Admin está nas rotas /admin/*
// (Painel Global — SaaS-wide, sem tenant). Serve para diferenciar o contexto
// SaaS-global do Modo Suporte (banner âmbar) dentro de um tenant.
export function GlobalAdminBanner() {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return null;
  if (user._impersonating) return null;
  if (!isSuperAdmin(user)) return null;
  if (!location.pathname.startsWith("/admin")) return null;
  return (
    <div
      data-testid="global-admin-banner"
      className="sticky top-0 z-50 w-full bg-gradient-to-r from-indigo-700 to-purple-700 text-white shadow-md"
    >
      <div className="max-w-full flex items-center justify-between gap-3 px-4 py-1.5 text-sm font-medium">
        <div className="flex items-center gap-2 min-w-0">
          <Shield className="w-4 h-4 shrink-0" />
          <span className="truncate">
            Modo Super Admin — <b>Painel Global</b>
          </span>
        </div>
        <span className="hidden sm:inline text-xs text-indigo-100 truncate">
          Gerenciamento SaaS · todas as empresas
        </span>
      </div>
    </div>
  );
}
